class LocalAppConfig {
    Get = () => {
        return JSON.parse(localStorage.getItem(`AppConfig`)) || {}
    }
    Set = (AppConfig) => {
        return localStorage.setItem(`AppConfig`, JSON.stringify(AppConfig))
    }
    Remove = () => {
        return localStorage.removeItem(`AppConfig`)
    }
}
export default new LocalAppConfig